interface LogoProps {
  className?: string
}

export function Logo({ className = '' }: LogoProps) {
  return (
    <div className={`flex items-baseline leading-none select-none ${className}`}>
      <span className="font-heading font-light text-[16px] text-forest-800 tracking-tight">
        UD
      </span>
      <span className="font-heading font-bold not-italic text-[16px] text-forest-500 tracking-tight ml-[3px]">
        GARDEN
      </span>
    </div>
  )
}
